const Message = ({ closestSkateboard }) => (
  <div className='message-view'>
    {closestSkateboard.image && (
      <img
        src={closestSkateboard.image}
        alt={`Board ${closestSkateboard.id}`}
        style={{ width: '100%', borderRadius: '6px', marginBottom: '8px', display: 'block' }}
      />
    )}
    <p style={{ margin: 0, textAlign: 'center', fontSize: '22px', letterSpacing: '0.01em' }}>
      {closestSkateboard.id ? `Board ${closestSkateboard.id}` : null}
    </p>
  </div>
)

export default Message
